import React from 'react';
import { Link } from 'react-router';
import type { ICellRendererParams } from 'ag-grid-community';
import { ADMIN, COMMITTEE_COORDINATOR, statusSubCampaign, WORKFLOW_TYPE } from '@/helpers/constants';
import { createRowLink } from '@/helpers/utils';
import useAuth from '@/hooks/useAuth';
import styles from './CampaignTitleCell.module.scss';

type FreeTextFilter = { value?: unknown } | undefined;

export const buildCampaignTitleCellRenderer = (freeTextFilter: FreeTextFilter, isSubCROverview = false) => {
  function CampaignTitleCell(params: ICellRendererParams) {
    const authService = useAuth();
    const row = params.data as Record<string, unknown> | undefined;

    if (!row) return null;

    const hasIcon = Boolean(row.isSubCRChildren) && row.statusCode === statusSubCampaign.IN_CONSOLIDATION
      && authService?.checkRoles([ADMIN, COMMITTEE_COORDINATOR]);

    const isApproved = (row.approvedByCampaignManager && row.workflowType === WORKFLOW_TYPE.DIGITAL)
      || row.workflowType !== WORKFLOW_TYPE.DIGITAL;

    return (
      <Link
        to={createRowLink(row, isSubCROverview, freeTextFilter)}
        className={hasIcon ? styles.LinkWithIcon : undefined}
        data-testid={row.id as string}
      >
        {hasIcon && (
          <i className={`di ${isApproved ? 'icon-kreis-check Green' : 'icon-kreis-loeschen Red'} ${styles.Icon}`} />
        )}
        <span>{params.value as React.ReactNode}</span>
      </Link>
    );
  }

  return CampaignTitleCell;
};
